import * as React from "react";
import { UploadBox } from "./UploadBox";

export function ComplianceSection() {
    const sections = [
        {
            title: "Agreement",
            uploadTitle: "Upload Media",
            maxImages: 3
        },
        {
            title: "Data Privacy Compliance Acknowledgement",
            uploadTitle: "Upload Media",
            maxImages: 3
        }
    ];

    return (
        <div className="flex flex-col px-5 py-5 mt-8 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
            <div className="w-full text-lg font-semibold text-gray-900 max-md:max-w-full">
                Compliance & Agreements
            </div>
            <div className="flex flex-col mt-5 w-full max-md:max-w-full">
                <div className="w-full max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col">
                        {sections.map((section, index) => (
                            <div key={index} className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                                <div className="flex flex-col grow max-md:mt-3 max-md:max-w-full">
                                    <div className="self-start text-base font-semibold text-gray-900">
                                        {section.title}
                                    </div>
                                    <div className="flex flex-col mt-2.5 text-center text-neutral-900 max-md:max-w-full">
                                        <UploadBox
                                            title={section.uploadTitle}
                                            maxImages={section.maxImages}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}